import { FormattedMessage } from 'react-intl'
import {
  Section,
  SectionContent,
  SectionHeader,
  SectionTitle,
  useFormValidation,
} from 'ui'
import type { RegularEffect as RegularEffectType } from '../../../../typings'
import { RegularBenefit } from './Benefit'
import { messages } from './messages'
import { RegularScope } from './Scope'
import { useRestrictionsByBenefit } from './useRestrictionsByBenefit'
import { benefitSuite, scopeSuite } from './validation'

type Props = {
  name: string
}

export function RegularEffect(props: Props) {
  const { name } = props

  useRestrictionsByBenefit({
    name: `${name}.benefit.type`,
  })

  const validation = (config: RegularEffectType, { intl }) => {
    scopeSuite(intl, `${name}.scope`)(config['scope'])
    benefitSuite(intl, `${name}.benefit`)(config['benefit'])
  }

  useFormValidation('regular-effect', {
    fieldName: name,
    validateFn: validation,
  })

  return (
    <Section>
      <SectionHeader>
        <SectionTitle>
          <FormattedMessage {...messages.title} />
        </SectionTitle>
      </SectionHeader>
      <SectionContent space="$space-10" fluid>
        <RegularScope name={`${name}.scope`} />
        <RegularBenefit name={`${name}.benefit`} />
      </SectionContent>
    </Section>
  )
}
